import React, { useState, useRef} from 'react'
import { Cropper, CircleStencil } from 'react-mobile-cropper'
import Icon from '../Icon'
import { prependServerDomain } from '../../utils/prependServerDomain'
import 'react-mobile-cropper/dist/style.css'
import './GalleryCropper.scss'

export const typeToDataURL = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
}

export const GalleryCropper = ({ item, onClose, onChange, validation,uiSchema, t, isCircleCrop, showApply, UStoreProvider}) => {
  const [imageToEdit] = useState(prependServerDomain(item.Url || item.ThumbnailUrl, UStoreProvider))
  const cropperRef = useRef(null)
  const [dimensions, setDimensions] = useState({width: item.Width, height: item.Height})
  const constraints = validation.reduce((acc, v) => ({
    ...acc,
    [v.validationType]: v
  }), {})


  const calcRatio = c => {
    if (!c) return
    const values = c.split(':')
    return values[0] / values[1]
  }

  const getDataUrl = () => {
    const canvas = cropperRef.current.getCanvas()
    if (canvas) {
      const fileSuffix = item.FileName?.split('.').pop().toLowerCase() || 'jpeg'
      const imageType = typeToDataURL[fileSuffix] || typeToDataURL['jpeg']
      const nonTransparentFormats = ['image/jpeg', 'image/bmp', 'image/tiff'];
      const format = nonTransparentFormats.includes(imageType) ? 'image/png' : imageType;
      return {width: canvas.width, height: canvas.height, dataUrl: canvas.toDataURL(format)}
    }
    return null
  }

  const onCropperChange = (cropper_state) => {
    const newDataUrl = getDataUrl()
    if (newDataUrl) {
      setDimensions({width: newDataUrl.width, height: newDataUrl.height})
    }
  }

  const onApply = (e) => {
    onChange(getDataUrl().dataUrl)
  }

  const onApplyAndClose = (e) => {
    onChange(getDataUrl().dataUrl, true)
    onClose()
  }

  const onReset = (e) => {
    cropperRef.current.reset()
  }

  const cropRatio = calcRatio(uiSchema['ui:options'].custom.cropRatio)
  const aspectRatio = cropRatio || {
    minimum: calcRatio(constraints.ImageRatio?.parameters.minimumValue),
    maximum: calcRatio(constraints.ImageRatio?.parameters.maximumValue),
  }

  const stencilSize = {
    maxWidth: constraints.ImageWidthRange?.parameters.maximumValue,
    maxHeight: constraints.ImageHeightRange?.parameters.maximumValue,
    minWidth: constraints.ImageWidthRange?.parameters.minimumValue,
    minHeight: constraints.ImageHeightRange?.parameters.minimumValue
  }

  return (
    <div className="xmp-gs-cropper-container">
      <div className="close-container">
        <div className="cropper-editor-title">{t('GallerySelectorDuc.ImageEditor')}</div>
        <div className="file-name">{item.FileName}</div>
        <div className="xmp-gs-cropper-reset-container">
          <Icon name="ImageDuc_Editor_Reset_mobile.svg" width="24px" height="24px" onClick={onReset} classes="xmp-gs-cropper-mobile-reset" />
          <Icon name="ImageDuc_Editor_Reset_Desktop.svg" width="24px" height="24px" onClick={onReset} classes="xmp-gs-cropper-desktop-reset" />
          <span className="xmp-gs-cropper-reset-text">{t( 'GallerySelectorDuc.Reset' )}</span>
        </div>
        <Icon name="closeBigWhite.svg" width="20px" height="20px" onClick={onClose}/>
      </div>
      <div className="xmp-gs-cropper-dimentions"> {t('GallerySelectorDuc.CropperDimensions',{height: dimensions.height, width: dimensions.width})}</div>
      <Cropper
        ref={cropperRef}
        src={imageToEdit}
        onChange={onCropperChange}
        className={'cropper'}
        stencilProps={{
          aspectRatio
        }}
        {...stencilSize}
        stencilComponent={isCircleCrop ? CircleStencil : undefined}
        imageRestriction={ 'none' }
      />
      <div className="cropper-buttons">
        <button
          className={`button button-primary gallery-cropper-apply ${showApply ? 'gallery-cropper-apply-hidden' : ''}`}
          onClick={onApply}>{t('GallerySelectorDuc.Apply')}</button>
        <button
          className={`button button-primary gallery-cropper-apply-and-close ${showApply ? 'gallery-cropper-apply-hidden' : ''}`}
          onClick={onApplyAndClose}>{t('GallerySelectorDuc.ApplyClose')}</button>
      </div>
    </div>
  )
}
